/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangedEvent } from '../../models/changed-event';

export interface GetStateChangedEvents$Params {
}

export function getStateChangedEvents(http: HttpClient, rootUrl: string, params?: GetStateChangedEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangedEvent>> {
  const rb = new RequestBuilder(rootUrl, getStateChangedEvents.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/event-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChangedEvent>;
    })
  );
}

getStateChangedEvents.PATH = '/routers/events/stateChanged';
